import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@99designs/react-components/components/Button';

import constants from 'contest/data/constants';
import DesignAction from './connected/design-action';

export class PrimaryActionButton extends React.Component {
    viewCustomerHandover() {
        return (
            <Button variations={['fluid', 'secondary']} href={this.props.design.links.handover}>
                <FormattedMessage id="view_files_action" />
            </Button>
        );
    }

    viewDesignerHandover() {
        return (
            <Button variations={['fluid', 'secondary']} href={this.props.design.links.handover}>
                <FormattedMessage id="upload_files_action" />
            </Button>
        );
    }

    render() {
        const actions = this.props.actions;

        if (actions[constants.VIEW_CUSTOMER_HANDOVER]) {
            return this.viewCustomerHandover();
        } else if (actions[constants.VIEW_DESIGNER_HANDOVER]) {
            return this.viewDesignerHandover();
        } else {
            return null;
        }
    }
}

PrimaryActionButton.propTypes = {
    design: PropTypes.object.isRequired,
    activeUser: PropTypes.object,
    actions: PropTypes.object.isRequired,
};

export default DesignAction(PrimaryActionButton);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/primary-action-button.jsx